// extracted by mini-css-extract-plugin
module.exports = {"Legend":"Legend_Legend__1HPsH"};